import { render, staticRenderFns } from "./ReceivedEmailsRow.vue?vue&type=template&id=45c09027&scoped=true&"
import script from "./ReceivedEmailsRow.vue?vue&type=script&lang=js&"
export * from "./ReceivedEmailsRow.vue?vue&type=script&lang=js&"
import style0 from "./ReceivedEmailsRow.vue?vue&type=style&index=0&id=45c09027&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45c09027",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('45c09027')) {
      api.createRecord('45c09027', component.options)
    } else {
      api.reload('45c09027', component.options)
    }
    module.hot.accept("./ReceivedEmailsRow.vue?vue&type=template&id=45c09027&scoped=true&", function () {
      api.rerender('45c09027', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/global/emails/components/receivedEmails/ReceivedEmailsRow.vue"
export default component.exports